module.exports = __webpack_public_path__ + "static/media/dotx-simple-icon.ca17d27b.svg";